import FileIcon from "@mui/icons-material/InsertDriveFileRounded";
import AudioIcon from "@mui/icons-material/LibraryMusic";
import PdfIcon from "@mui/icons-material/PictureAsPdf";
import VideoIcon from "@mui/icons-material/SmartDisplay";
import { Grid, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { memo } from "react";
import { GetType } from "./GetFileType";

function ClientSitefilingListing({ item, setShowFilePreviewFile, setShowFilePreview, textItems }) {
  const handleShowPreview = (file) => {
    setShowFilePreview(true);
    setShowFilePreviewFile(file);
  };

  const checkFileType = (file, size) => {
    let src = file?.thumbFileUrl ?? file?.fileUrl;

    switch (GetType(file?.name)) {
      case "image":
        return (
          <img
            style={{
              width: `${size}px`,
              height: `${size}px`,
              objectFit: "cover",
              borderRadius: size == 100 ? "10px" : "0px"
            }}
            alt="file"
            src={src}
          />
        );
      case "audio":
        return (
          <AudioIcon
            sx={{
              height: `${size}px`,
              width: `${size}px`,
              color: "#a4a4a4"
            }}
          />
        );
      case "video":
        return (
          <VideoIcon
            sx={{
              height: `${size}px`,
              width: `${size}px`,
              color: "#a4a4a4"
            }}
          />
        );
      case "pdf":
        return (
          <PdfIcon
            sx={{
              height: `${size}px`,

              width: `${size}px`,
              color: "#a4a4a4"
            }}
          />
        );
      case undefined:
        return (
          <>
            <div
              style={{
                height: `${size}px`,
                width: `${size}px`
              }}></div>
          </>
        );
      default:
        return (
          <FileIcon
            sx={{
              height: `${size}px`,
              minHeight: `${size}px`,
              minWidth: `${size}px`,
              width: `${size}px`,
              color: "#a4a4a4"
            }}
          />
        );
    }
  };
  const ListingComponent = ({ file }) => {
    return (
      <div onClick={() => handleShowPreview(file)}>
        <Stack sx={{ display: "flex",  justifyContent: "center", alignItems: "center" }}  direction={"column"}>
          {checkFileType(file, 100)}
          <Typography
            sx={{
              wordBreak: "break-all",
              display: "-webkit-box",
              overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2,
              textAlign: "center"
            }}>
            {file?.name}
          </Typography>
          <Typography
            sx={{
              color: "#6e6e6e"
            }}>
            {dayjs(file?.dateCreated).format("YYYY-MM-DD")}
          </Typography>
        </Stack>
      </div>
    );
  };

  const FolderComponent = ({ file }) => (
    <>
      <div>
        <Stack sx={{ display: "flex",  justifyContent: "center", alignItems: "center" }}  direction={"column"}>
          <div style={{ overflow: "hidden", borderRadius: "10px" }}>
            <Grid spacing={0.2} gridTemplateColumns={"100px 100px"} container width={"100px"}>
              {Array.from({ length: 4 })?.map((_, i) => (
                <Grid sx={{ alignItems: "center", overflow: "hidden",
                    backgroundColor: "#e4e4e4" }} key={i} justifyItems={"center"} size={6}>
                  {checkFileType(file?.folderFileList[i], 50)}
                </Grid>
              ))}
            </Grid>
          </div>
          <Typography
            sx={{
              textAlign: "center",
              wordBreak: "break-word"
            }}>
            {file?.name}
          </Typography>
          <Typography
            sx={{
              color: "#6e6e6e"
            }}>
            {file?.folderFilesCount} {textItems}
          </Typography>
        </Stack>
      </div>
    </>
  );
  return (
    <div>
      {item?.fileType == "" && <FolderComponent file={item} textItems={textItems} />}
      {item?.fileType != "" && <ListingComponent file={item} textItems={textItems} />}
    </div>
  );
}

export default memo(ClientSitefilingListing);
